// resources/ThemeSync.tsx
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import type { RootState } from 'redux/store'

export default function ThemeSync() {
	const dark = useSelector((s: RootState) => s.appSettings.darkTheme)

	useEffect(() => {
		// After redux changes, the CSS var already has the right value.
		const bg = getComputedStyle(document.documentElement).getPropertyValue('--app-bg').trim()
		document.documentElement.style.backgroundColor = bg
		document.body.style.backgroundColor = bg

		let meta = document.querySelector('meta[name="theme-color"]')
		if (!meta) {
			meta = document.createElement('meta')
			meta.setAttribute('name', 'theme-color')
			document.head.appendChild(meta)
		}
		meta.setAttribute('content', bg)

		document.documentElement.classList.toggle('dark', dark)
	}, [dark])

	return null
}
